import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

// Component
import ImageShow from "views/components/ImageShow";

export default function MenuListBar({ isLargeScreen, menu_second }) {
    const history = useNavigate();
    const [dataList, setDataList] = useState([]);
    const menuList = [
        {
            "icon": "/images/icon/promotion.webp",
            "name": "โปรโมชั่น",
            "status": 1,
            "link": "/promotion"
        },
        {
            "icon": "/images/icon/aff.webp",
            "name": "เชิญเพื่อน",
            "status": 1,
            "link": "/affiate"
        },
        {
            "icon": "/images/icon/cashback.webp",
            "name": "รับทรัพย์",
            "status": 1,
            "link": "/cashback"
        },
        {
            "icon": "/images/icon/wheel.webp",
            "name": "กงล้อลุ้นโชค",
            "status": 1,
            "link": "/wheel"
        },
        {
            "icon": "/images/icon/history.webp",
            "name": "ประวัติ",
            "status": 1,
            "link": "/history"
        },
        {
            "icon": "/images/icon/profile.webp",
            "name": "ข้อมูลผู้ใช้",
            "status": 1,
            "link": "/profile"
        }
    ];

    useEffect(() => {
        if(menu_second !== undefined) {
            if(menu_second === null) {
                setDataList(menuList);
            }
            else {
                if(menu_second.length > 0) {
                    setDataList(menu_second);
                }
                else {
                    setDataList(menuList);
                }
            }
        }
    }, [menu_second]);

    return (
        isLargeScreen ?
            <div
                className="menuPositionWidthScroll flexCenter"
            >
                {
                    dataList.map((item, index) => (
                        <div className="menuBar center cursorPointer" key={index} onClick={() => history(item.link)}>
                            <ImageShow className="menuBarImage" src={item.icon} altText="เมนูค่ายเกม" />
                            <div className="menuBarText">
                                {
                                    item.name
                                }
                            </div>
                        </div>
                    ))
                }
            </div>
            :
            <div
                className="menuPositionWidthScroll"
            >
                <div className="displayFlex">
                    {
                        dataList.map((item, index) => (
                            <div className="menuBar center cursorPointer" key={index} onClick={() => history(item.link)}>
                                <ImageShow className="menuBarImage" src={item.icon} altText="เมนูค่ายเกม" />
                                <div className="menuBarText">
                                    {
                                        item.name
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
    );
}